import { ConcatAddressLine, joinPositional } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

const usaIsoName = 'United States of America';
const usaAliases = ['us', 'usa', 'united states'];

function isUnitedStatesCountry(country) {
  const normalisedCountry = country?.toLowerCase();

  if (!normalisedCountry) {
    return false;
  }

  return normalisedCountry === usaIsoName.toLowerCase() || usaAliases.includes(normalisedCountry);
}

function GetW9FieldPathValueMap(addressPath, wellFormedAddress) {
  const isUnitedStates = isUnitedStatesCountry(wellFormedAddress?.addressCountry);

  const cityStateAndZipParts = [
    wellFormedAddress?.addressLine3 ?? '',
    wellFormedAddress?.addressLine4 ?? '',
    wellFormedAddress?.addressPostalCode ?? ''
  ];

  if (!isUnitedStates && wellFormedAddress?.addressCountry) {
    cityStateAndZipParts.push(wellFormedAddress.addressCountry);
  }

  const countryValue = isUnitedStates
    ? usaIsoName
    : (wellFormedAddress?.addressCountry ?? '');

  const countrySpecified = !isUnitedStates && !!wellFormedAddress?.addressCountry;

  const fieldPathValueDictionary = [
    { key: `${ addressPath }.numberStreet`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityStateAndZipCode`, value: joinPositional(cityStateAndZipParts) },
    { key: `${ addressPath }.country`, value: countryValue },
    { key: `${ addressPath }.countrySpecified`, value: countrySpecified }
  ];

  return fieldPathValueDictionary;
}

function GetW9WellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    // Default W9 country is the United States. Non-US countries will
    // be set explicitly based on the stored form values.
    country: usaIsoName,
    countrySpecified: formAddress?.countrySpecified ?? false
  };

  if (!formAddress) {
    return wellFormedAddress;
  }

  const splitLine1 = formAddress?.numberStreet?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }
  wellFormedAddress.line3 = formAddress.cityStateAndZipCode;

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  return GetW9FieldPathValueMap('address', wellFormedAddress);
}

export function GetWellFormedAddress(addressProps, addressValues) {
  return GetW9WellFormedAddress(addressValues?.address);
}
